<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "SliderComponent",
};
</script>

<style scoped></style>
